import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import MapSection from '../common/MapSection';
import HeatMap from '../common/charts/HeatMap';
import Methodology from '../common/Methodology';

const SocialDialogueIndicator = props => {

	const mapChartID = 20147;
	const mapIndicators = [
		{
			id: '441',
			literalId: '20817'
		},{
			id: '442',
			literalId: '20818'
		},{
			id: '443',
			literalId: '20819'
		}
	];

	const [selectedChart, setSelectedChart] = useState('map');

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L20811 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	const changeChart = () => {
		let selectedChartValue = 'map';
		if (selectedChart == 'map')
		{
			selectedChartValue = 'heat-map';
		}
		setSelectedChart(selectedChartValue);
	}

	return(
		<div className="social-dialogue-indicator">
			<AdviceSection literals={ props.literals } section={["osh-steering","social-dialogue-indicator"]} methodologyData={{section: 'osh-steering', subsection: 'Social dialogue indicator', indicator: 444}} />

			<section className="container">

				{ (selectedChart == 'map') && 
					<React.Fragment>
						<p className="btn--wrapper text-center">
							<button onClick={ changeChart } className="btn-default btn-main-color text-center ">{ props.literals.L20820 }</button>
						</p>
						<MapSection 
							literals = { props.literals }
							chartID = { mapChartID }
							indicatorList = { mapIndicators }
							selectedIndicator = { mapIndicators[2] }
							showEUBanner = { false }
						/>
					</React.Fragment>
				}

				{ ( selectedChart == 'heat-map') && 
					<React.Fragment>
						<p className="btn--wrapper text-center">
							<button onClick={ changeChart } className="btn-default btn-main-color text-center ">{ props.literals.L20821 }</button>
						</p>
						<HeatMap
							literals = { props.literals }
							title = { props.literals.L20028 }
							chart = { mapChartID }
							xAxisCategories = { [ props.literals.L20817, props.literals.L20818, props.literals.L20819 ] }
						/>
					</React.Fragment>
				}

				<Methodology literals={ props.literals } section={ 'Social dialogue indicator' } />
			</section>
		</div>
	)
}
SocialDialogueIndicator.displayName = 'SocialDialogueIndicator';
export default SocialDialogueIndicator;